import { render } from "./ArtistKachel.vue?vue&type=template&id=e682108a&scoped=true"
import script from "./ArtistKachel.vue?vue&type=script&lang=js"
export * from "./ArtistKachel.vue?vue&type=script&lang=js"

import "./ArtistKachel.vue?vue&type=style&index=0&id=e682108a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e682108a"]])

export default __exports__